import { Rop } from './Rop.js'

export { Rop } from './Rop.js'

/**
 * A quick alias for `Rop.INST.o`
 */
export const o = Rop.INST.o
